import React from "react";
import "./logoNew.css";
import LogoSvg from "../../assets/assets/images/01_logo_hub.svg";

const LogoNew = (props) => {
  const { style, className } = props;
  return (
    <div
      style={style}
      className={className ? "hub_logo " + className : "hub_logo"}
    >
      <img src={LogoSvg} alt="logo" />
    </div>
  );
};

export default LogoNew;
